import routes from './routes';
import { createWebHistory, createRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore'
import { normalizeAuthToken } from '@/utils/helpers'
import { savePendingAccessLink } from '@/utils/pendingTeamLink'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Wait until user is fetched before resolving protected routes
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()

  // ✅ Allow public routes to pass through
  const exactPublicRoutes = [
    '/verify',
    '/demo',
    '/reset',
    '/qa/ai-assistant-trust',
    '/analyze/intro',
    '/analyze/details',
    '/analyze/aspirations',
    '/next-steps',
    '/reject-profile',
    '/reject-statsheet',
  ]
  const prefixPublicRoutes = ['/welcome']
  const isPublicProfile = /^\/profile\/[^/]+$/.test(to.path)
  const isPublicMember = /^\/member\/[^/]+$/.test(to.path)
  const isPublicStatsheet = /^\/statsheet\/[^/]+$/.test(to.path)
  const isPublicReview = /^\/review\/[^/]+$/.test(to.path)
  const isPublic =
    exactPublicRoutes.includes(to.path) ||
    prefixPublicRoutes.some((path) => to.path.startsWith(path)) ||
    isPublicProfile ||
    isPublicMember ||
    isPublicStatsheet ||
    isPublicReview

  if (isPublic) {
    return next()
  }

  if (userStore.user) {
    if (to.meta?.requiresAdmin && !userStore.user?.isAdmin && !(to.meta?.allowSuperUser && userStore.user?.isSuperUser)) {
      return next('/')
    }
    if (to.meta?.requiresSuperUser && !userStore.user?.isSuperUser) {
      return next('/')
    }
    return next()
  }

  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('teamwrkr-token='))
    ?.split('=')[1]

  if (!token) {
    // spec-admin-gated-company-access: keep an access-request decision link through sign-in.
    if (to.path === '/team-confirmation' && typeof to.query?.access === 'string' && to.query.access) {
      savePendingAccessLink(to.query.access)
      return next('/verify')
    }
    return next('/welcome')
  }

  try {
    await userStore.fetchUser(normalizeAuthToken(token))

    if (!userStore.user?._id) {
      return next('/welcome')
    }

    if (to.meta?.requiresAdmin && !userStore.user?.isAdmin && !(to.meta?.allowSuperUser && userStore.user?.isSuperUser)) {
      return next('/')
    }
    if (to.meta?.requiresSuperUser && !userStore.user?.isSuperUser) {
      return next('/')
    }

    return next()
  } catch (e) {
    console.warn('User fetch failed', e)
    return next('/welcome')
  }
})


export default router;
